<template>
  <div id="loggedInPage" class="container p-sm-0">
    <div v-if="banner.length > 0 && isLoaded" class="row">
      <div class="col-md-6 col-sm-10 col-12 mx-auto">
        <carousel
            :autoplay="true"
            :dots="false"
            :items="1"
            :margin="5"
            :nav="false"
            :rtl="true">
          <div v-for="item in banner"
               :key="item.BanerID">
            <img :src="$replaceHttps(item.FileUrl)" alt="بنر" class="img-fluid">
          </div>
        </carousel>
      </div>
    </div>
    <div v-if="isLoaded" class="row p-3 pt-0">
      <v-card
          class=" p-4 my-2 mx-auto rounded-xl  col-md-6 col-sm-10 col-12 mx-auto">
        <div  class="text-center">
          <img :src="$replaceHttps(schoolInfo.FileUrl)" alt="logo" height="100">
          <div class="font16px my-2 mb-5">{{ schoolInfo.Name }}</div>
          <div class="gray-color font12px"><i class="fas fa-user ml-1"></i>نام و نام خانوادگی دانش آموز</div>
          <div>{{ studentInfo.firstName }} {{ studentInfo.lastName }}</div>
        </div>
        <div class="d-flex justify-space-between mt-5 pt-4">
          <v-btn class="gradient-btn" icon @click="goToHome"><i class="fas fa-sign-in-alt"></i></v-btn>
          <v-btn class="purple-gradient-btn" icon @click="logOut"><i class="fas fa-long-arrow-left"></i></v-btn>
        </div>
      </v-card>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import carousel from "xx-vue-owl-carousel";

export default {
  name: "LoggedIn",

  metaInfo: {
    title: 'مسیربرتر-ورود'
  },
  components: {
    carousel
  },
  data: () => ({
    isLoaded: false,
    showLoaderDialog: false,
    banner: [],
    studentInfo: null,
    schoolInfo:null
  }),
  mounted() {
    _this = this;
    this.studentInfo = this.$getUserData()
    this.getData()
    this.getSchoolInfo()
  },
  methods: {
    getData() {
      this.showLoaderDialog= true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/GeneralBanner", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            _this.banner = json.Baners.filter(x=> x.IsActive= true)

            this.showLoaderDialog= false
            let _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/)
            if (_iOSDevice) {
              this.$addToHomescreen.mount({
                lang: "en_GB",
                buttonColor: "#8057EF",
                title: 'وب اپلیکیشن مسیر برتر',
                iconPath: 'https://masirebartarapp.com/favicon.ico',
                content: 'مسیر برتر را به صفحه اصلی موبایل خود اضافه کنید'
              });
            }
          })
          .catch(error => console.log('error', error));
    },
    getSchoolInfo(){
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Index", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json =JSON.parse(result).School;
            _this.schoolInfo = json
            _this.$setSchoolInfo(json.Name,json.FileUrl,json.SchoolID, json.TypeDisplayScore)
            _this.isLoaded=true
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToHome() {
      this.$router.replace({path: 'Home'})
    },
    logOut() {
      this.$setUserData('', '', '', '', '', '', '','','','');
      this.$setUserLogo('');
      this.$setSchoolInfo('', '', '')
      this.$setModalID('')
      this.$router.replace({path: 'Login'})
    }
  }
}
</script>

